import classNames from 'classnames';
import styles from './PodcastAudio.module.scss';
import { Container, Heading } from 'ui/components';
import { useEffect, useRef } from 'react';

export interface PodcastAudioProps {
	className?: string;
	heading?: string;
	text?: string;
	embedCode?: string;
	audio?: {
		documentType: 'umbracoMediaAudio';
		url: string;
		focalPoint?: unknown;
		properties: {
			umbracoFile: string;
			umbracoExtension: string;
			umbracoBytes: string;
		};
	};
}

export const PodcastAudio: React.FC<PodcastAudioProps> = ({
	className,
	heading,
	text,
	audio,
	embedCode
}) => {
	const embedRef = useRef<HTMLDivElement | null>(null);
	const hasEmbedCode = Boolean(embedCode?.trim());

	useEffect(() => {
		const container = embedRef.current;

		if (!container || !embedCode?.trim()) {
			return;
		}

		const fragment = document
			.createRange()
			.createContextualFragment(embedCode);

		container.replaceChildren(fragment);

		return () => {
			container.replaceChildren();
		};
	}, [embedCode]);

	return (
		<Container width="Standard" className={styles.PodcastAudio_Container}>
			<div className={classNames(styles.PodcastAudio, className)}>
				{heading && (
					<Heading
						headingLevel="h2"
						style="sm"
						className={styles.PodcastAudio_heading}
					>
						{heading}
					</Heading>
				)}

				<div className={styles.PodcastAudio_content}>
					{hasEmbedCode ? (
						<div
							ref={embedRef}
							className={styles.PodcastAudio_embed}
						/>
					) : audio?.url ? (
						<div className={styles.PodcastAudio_player}>
							<audio
								controls
								preload="metadata"
								src={audio.url}
							>
								Din browser understøtter ikke afspilning af lyd.
							</audio>
						</div>
					) : null}

					{text && (
						<div
							className={styles.PodcastAudio_text}
							dangerouslySetInnerHTML={{ __html: text }}
						/>
					)}
				</div>
			</div>
		</Container>
	);
};